import { render, staticRenderFns } from "./WalletButton.vue?vue&type=template&id=cd534df0"
import script from "./WalletButton.vue?vue&type=script&lang=ts"
export * from "./WalletButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports